import { Button, Dropdown } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { tracRoutes } from "src/data/routes";
import { useAnalytics } from "src/hooks/analytics.hook";

const languages = [
  { value: "en", label: "English", slug: "en-US" },
  { value: "fr", label: "Français", slug: "fr-FR" },
];
export const LanguageSwitcher = () => {
  const [language, setLanguage] = useState<any>();
  const [changed, setChanged] = useState<any>(false);
  const { i18n } = useTranslation();
  const { track} = useAnalytics();
  const location = useLocation();

  const handleChange = (index: string) => {
    setLanguage(languages[+index]);
    i18n.changeLanguage(languages[+index].value);
    setChanged(true);
  };

  useEffect(() => {
    const lang = languages.find(
      (elt) => elt.slug === i18n.language || elt.value === i18n.language
    );
    setLanguage(lang);
  }, []);

  useEffect(() => {
    if (language && changed) {
      track("Setting", {
        page_current: tracRoutes.find((route) =>
          location.pathname?.includes(route?.route)
        )?.page,
        element_type: "drop-down",
        setting_name: "language",
        value_set: language.label,
        setting_affects: "website",
      });
      setChanged(false);
    }
  }, [changed]);
  const items = getItems(languages);
  return (
    <Dropdown
      menu={{ items, onClick: (info) => handleChange(info.key) }}
      placement="bottom"
      trigger={["click", "contextMenu"]}
    >
      <Button className="bg-unset border-none p-0">
        <img
          src={`/icons/${language?.value}.png`}
          alt={language?.value}
          className="w-8 h-8"
        />
      </Button>
    </Dropdown>
  );
};

const getItems = (items: any[]) => {
  return items?.map((item, index) => {
    return {
      key: index.toString(),
      label: <span>{item.label}</span>,
    };
  });
};
